<template>
  <div class="my-scenarios reverse-mobile" id="my-scenarios">
    <div class="row reverse-mobile">
      <div class="col-12 col-md-3">
        <UserMenu></UserMenu>
      </div>
      <div
        v-if="isLoading"
        class="w-75 d-flex position-absoloute flex-column justify-content-center align-items-center"
        style="margin-top: 295px;"
      >
        <PleaseWait></PleaseWait>
      </div>

      <div
        class="w-75 d-flex position-absoloute flex-column justify-content-center align-items-center"
        v-if="scenariosCount <= 0 && !isLoading"
      >
        <NoContributed></NoContributed>
      </div>

      <div v-else class="col-sm col-md-9 col-lg-9 scenario-scroll-page">
        <div class="row d-flex justify-content-between mx-2">
          <div class="row mb-0">
            <div class="d-flex flex-row align-items-center">
              <i class="material-icons material-icons-title mr-2">insert_chart_outlined</i>
              <h2 class="mt-2">My Scenarios</h2>
            </div>
          </div>
          <div v-if="scenariosCount > 0 && !isLoading" class="results-count">
            <b class="deep">({{ scenariosCount }})</b>
            Scenario{{ scenariosCount != 1 ? 's' : '' }} available
          </div>
        </div>
        <div class="row d-flex justify-content-between">
          <div class="dropdown ml-4" v-if="scenariosCount > 0 && !isLoading">
            <button class="btn btn-primary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{currentSortByName}}</button>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <span class="dropdown-item" v-for="sorter in sortByFields" :key="sorter.id" @click="sortBy(sorter)">{{sorter.name}}</span>
            </div>
          </div>
          <div
            v-if="scenariosCount > 0 && !isLoading"
            class="pagination-wrapper col-8 d-flex justify-content-end mt-0 mr-3"
          >
            <template>
              <paginate
                v-model="page"
                :page-count="pageCount"
                :page-range="3"
                :margin-pages="2"
                :click-handler="clickCallback"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :container-class="'pagination'"
                :page-class="'page-item'"
              ></paginate>
            </template>
          </div>
        </div>
        <div class="placeholder">
          <MyScenario
            v-for="scenario in scenarioObjects"
            v-bind:key="scenario.id"
            :uuidId="scenario.uuid_id"
            :deviceId="scenario.device_id"
            :userId="scenario.contributed_by.id"
            :name="scenario.name"
            :description="scenario.description"
            :file-size="scenario.file_size"
            :language="scenario.unicode_language_identifier"
            :numEvents="scenario.num_events"
            :numChecklistItems="scenario.num_checklist_items"
            :hasMedia="scenario.has_video"
            :tags="scenario.tags"
            :hasImages="scenario.has_images"
            :hasSounds="scenario.has_sounds"
            :hasLabs="scenario.has_labs"
            :objectUrl="scenario.object_url"
            :durationInSeconds="scenario.duration_in_seconds"
            :numDownloads="scenario.num_downloads"
            :contributedBy="scenario.contributed_by.publicUsername"
            :isFavouritedByUser="scenario.is_favourited_by_current_user"
            :numberFavourites="scenario.number_favourites"
            :privacyLevel="scenario.privacy_level"
            :isPublishable="scenario.is_publishable"
            :isProcessed="scenario.is_processed"
          ></MyScenario>
        </div>

        <div class="row d-flex justify-content-center">
          <div
            v-if="scenariosCount > 0"
            class="pagination-wrapper col-12 d-flex justify-content-end mt-3 mr-5"
          >
            <template>
              <paginate
                v-model="page"
                :page-count="pageCount"
                :page-range="3"
                :margin-pages="2"
                :click-handler="clickCallback"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :container-class="'pagination'"
                :page-class="'page-item'"
              ></paginate>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import scenService from "../services/scenarios.service";
import Paginate from "../components/Paginate";
import MyScenario from "../components/MyScenario";
import UserMenu from "../components/UserMenu";
import { isNull } from "util";
import ScenarioObject from "../objects/ScenarioObject";
import NoContributed from "../components/NoContributed";
import PleaseWait from "../components/PleaseWait";

export default {
  name: "MyScenarios",
  components: {
    MyScenario,
    UserMenu,
    Paginate,
    NoContributed,
    PleaseWait
  },
  data: function() {
    return {
      isLoading: true,
      NUMBER_TO_GET: 5,
      pageCount: 0,
      page: 0,
      from: 0,
      to: 0,
      scenarios: [],
      scenarioTags: [],
      scenariosCount: 0,
      pageNum: 0,
      scenarioObjects: [],
      isActive: false,
      sortByFields: [
        { id: 'dateAsc', name: 'Created Date ▼', isSelected: true },
        { id: 'dateDesc', name: 'Created Date ▲', isSelected: false },
        { id: 'nameAsc', name: 'Name ▼', isSelected: false },
        { id: 'nameDesc', name: 'Name ▲', isSelected: false },
      ],
      currentSortByName: 'Created Date ▼'
    };
  },
  methods: {

    sortBy(sorter) {
      this.currentSortByName = sorter.name;
      this.sortByFields.forEach(x => x.isSelected = false);
      sorter.isSelected = true;

      let sortDir = sorter.id.includes('Asc') ? 'ASC' : 'DESC';
      let sortBy = sorter.id.includes('date') ? 'contributedAt' : 'name';

      // page zero and one are the same 
      let startAtPage = this.page < 2 ? 0 : this.page - 1;

      this.getScenarios(this.NUMBER_TO_GET * startAtPage, sortBy, sortDir);
    },

    getScenarios(startAt, sortBy, sortDirection) {
      this.isLoading = true;
      this.isActive = true;
      scenService.myScenarios(startAt, this.NUMBER_TO_GET, sortBy, sortDirection)
        .then(data => {
          this.scenariosCount = data.total;
          this.scenarioObjects = [];
          for (let scenario in data.scenarios) {
            this.scenarioObjects.push(
              new ScenarioObject(data.scenarios[scenario])
            );
          }
          this.from = parseInt(data.from);
          this.to = parseInt(data.to);
          this.updatePageCount();
          this.isLoading = false;
        });

      this.isActive = false;
    },

    clickCallback: function(pageNum) {
      this.isActive = true;

      window.scrollTo(0, 0);
      this.page = pageNum;
      pageNum = pageNum - 1;
      this.scenarioObjects = [];

      let currentSorter = this.sortByFields.find(x => x.isSelected);
      let sortDir = currentSorter.id.includes('Asc') ? 'ASC' : 'DESC';
      let sortBy = currentSorter.id.includes('date') ? 'contributedAt' : 'name';

      this.getScenarios(this.NUMBER_TO_GET * pageNum, sortBy, sortDir);
    },
    updateFavouriteScenariosList() {
      this.$parent.updateFavouriteScenariosList();
    },
    updatePageCount() {
      this.pageCount = Math.ceil(this.scenariosCount / this.NUMBER_TO_GET);
    }
  },

  beforeMount() {
    this.isLoading = true;
    this.getScenarios();
  }
};
</script>

<style scoped>

.dropdown-item {
  cursor: pointer;
}

.dropdown-toggle::after {
  display:none;
}

.placeholder {
  min-height: 900px;
  z-index: 9;
  margin-bottom: 30px;
}

.scenario {
  min-height: 450px;
  margin-bottom: 70px;
}
.scenario {
  overflow: hidden;
}
@media (min-width: 992px) {
  .scenario-scroll-page {
  }
}
.lds-grid {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
  position: absoloute;
  top: 0;
  left: 0;
  right: 0;
}
.lds-grid div {
  position: absolute;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: #CB2E37;
  animation: lds-grid 1.2s linear infinite;
}
.lds-grid div:nth-child(1) {
  top: 6px;
  left: 6px;
  animation-delay: 0s;
}
.lds-grid div:nth-child(2) {
  top: 6px;
  left: 26px;
  animation-delay: -0.4s;
}
.lds-grid div:nth-child(3) {
  top: 6px;
  left: 45px;
  animation-delay: -0.8s;
}
.lds-grid div:nth-child(4) {
  top: 26px;
  left: 6px;
  animation-delay: -0.4s;
}
.lds-grid div:nth-child(5) {
  top: 26px;
  left: 26px;
  animation-delay: -0.8s;
}
.lds-grid div:nth-child(6) {
  top: 26px;
  left: 45px;
  animation-delay: -1.2s;
}
.lds-grid div:nth-child(7) {
  top: 45px;
  left: 6px;
  animation-delay: -0.8s;
}
.lds-grid div:nth-child(8) {
  top: 45px;
  left: 26px;
  animation-delay: -1.2s;
}
.lds-grid div:nth-child(9) {
  top: 45px;
  left: 45px;
  animation-delay: -1.6s;
}

.scenario-elements li i {
  margin-right: 5px;
}

.scenario-elements {
  height: 50px;
  background-attachment: #CB2E37;
}

@keyframes lds-grid {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}
.results-count {
  color: #6c757d;
  font-size: 14px;
}

.deep {
  color: #CB2E37;
}

/* Medium Devices, Desktops */
@media only screen and (max-width: 992px) {
  .pagination-wrapper {
    margin: 0px !important;
    padding: 0px !important;
    display: flex;
  }
  .pagination-wrapper ul {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
}

.material-icons-title {
  font-size: 50px;
  color: #7d7d7d;
}
</style>
